import React from 'react';
import Shifts from '../components/vardiya/Shifts';

const ShiftsPage: React.FC = () => {
  return (
    <Shifts />
  );
};

export default ShiftsPage; 